/**
 * Inline styles for the variant-B look.
 *
 * Stencil has no token for any of these: the card sits on a warm off-white that is not a background
 * token (`sui-bg-subtle` is the cooler #F3F3F3), and Tailwind's gradient stops are restricted to
 * Stencil background tokens, so `sui-from-*`/`sui-to-*` cannot express the accent gradient.
 * Everything else in variant-B is Stencil components and `sui-` classes.
 */

/** The design's "Darker gradient", evenly distributed across its five stops. */
const ACCENT_STOPS = '#F26422 0%, #B93756 25%, #872266 50%, #442264 75%, #0B0910 100%';

const CARD_FILL = '#F9F6F4';

/**
 * The pill's `Pill/Outline/fill` is #FFFFFF at 60%, which Stencil's Pill already applies as
 * `sui-bg-primary/60`. It has to be restated opaquely here because the gradient-border technique
 * below paints the pill's interior itself: #FFFFFF at 60% over the card's #F9F6F4.
 */
const PILL_FILL = '#FDFBFB';

export const BANNER_STYLE = { backgroundColor: CARD_FILL };

/** The rail runs straight down; the design's 0deg is the layer's rotation, not a gradient axis. */
export const RAIL_STYLE = { backgroundImage: `linear-gradient(to bottom, ${ACCENT_STOPS})` };

/**
 * A 1px gradient border, which CSS has no single property for — `border-image` would paint a
 * square ring and ignore the pill's radius. Instead the first background paints the pill's fill
 * over the padding box, and the second shows through the transparent border only.
 *
 * Passed to Stencil's `Pill` as `style`, which lands on the root element: it overrides only the
 * border colour and fill, leaving Pill's own height, radius, padding, border width and states.
 */
export const PILL_STYLE = {
  borderColor: 'transparent',
  backgroundImage: `linear-gradient(${PILL_FILL}, ${PILL_FILL}), linear-gradient(135deg, ${ACCENT_STOPS})`,
  backgroundOrigin: 'border-box',
  backgroundClip: 'padding-box, border-box',
};
